<template>
  <div class="table">
    <div class="params-form">
      <a-form-model ref="searchForm" layout="inline" :model="formState">
        <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
        <a-form-model-item label="任务编号" prop="taskCode">
          <a-input v-model="formState.taskCode"  placeholder="请输入任务编号"></a-input>
        </a-form-model-item>
        <a-form-model-item label="检查时间" prop="checkDate">
          <a-ext-data-picker v-model="formState.checkDate"></a-ext-data-picker>
        </a-form-model-item>
        <a-form-model-item label="被检机构名称" prop="name">
          <a-input v-model="formState.name"  placeholder="请输入被检机构名称"></a-input>
        </a-form-model-item>
        <a-form-model-item label="任务状态" prop="taskStatus">
          <div style="display: inline-block;width: 100px">
          <a-ext-local-dic-select dic-key="DoubleCheckStatus" v-model="formState.taskStatus"></a-ext-local-dic-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="专家姓名" prop="zhuanjiaName">
          <a-input v-model="formState.zhuanjiaName"  placeholder="请输入专家姓名"></a-input>
        </a-form-model-item>
        <a-form-model-item label="检查结果" prop="taskPass">
          <div style="display: inline-block;width: 100px">
          <a-ext-local-dic-select dic-key="DoubleCheckResult" v-model="formState.taskPass"></a-ext-local-dic-select>
          </div>
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button @click="onResetSearch">重置</a-button><a-divider dashed="true" type="vertical" />
            <a-button type="primary" @click="onSearchPage">查询</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="table-content">
      <div>
        <div class="title" style="width: 350px;display: inline-block">
          检测机构双随机检查
          <div v-if="selectedRowCount" style="width: 150px;display: inline-block;line-height: 20px;color: darkorange">
            共选择{{selectedRowCount}}条
          </div>
        </div>

        <div class="btn" style="width: calc(100% - 350px);display: inline-block;text-align: right">
          <a-space>
            <!--<a-button type="primary" @click="onAddDbRandomModalOpen" style="margin-right: 10px">生成任务</a-button>-->
            <a-button type="primary" @click="onExportExcel">导出excel</a-button>
            <a-divider dashed="true" type="vertical" />
            <a-button type="danger" @click="onBatchDelete">批量删除</a-button>
          </a-space>
        </div>
      </div>


      <a-config-provider :locale="locale">
        <a-table
                :data-source="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="loading"
                row-key="id"
                :row-selection="{
                        selectedRowKeys: selectedRowKeys,
                        onChange: onSelectChange,
                    }"
                @change="onPageChange"
                :scroll="{ y: 500 }"
        >
          <template slot="zhuangtai" slot-scope="text, record">
            <span v-if="record.taskStatus==='待执行'" style="color: #3498db">待执行</span>
            <span v-else-if="record.taskStatus==='已执行'" style="color: green">已执行</span>
            <span v-else-if="record.taskStatus==='执行中'" style="color: orange">执行中</span>
          </template>
          <template slot="xianchangjianchabiao" slot-scope="text, record">
            <span v-if="record.xcjcbId" style="color: green;cursor: pointer"  href="javascript:void(0);" @click="$plugins.preview(record.xcjcbId,'pdf')">查看</span>
            <span v-else style="color:#3498db;cursor: pointer " @click="choiceImg(record,'现场检查表','现场检查表')">暂无</span>
          </template>
          <template slot="wentiquerenbiao" slot-scope="text, record">
            <span v-if="record.wtqrbId" style="color: green;cursor: pointer" href="javascript:void(0);" @click="$plugins.preview(record.wtqrbId,'pdf')">查看</span>
            <span v-else style="color:#3498db ;cursor: pointer" @click="choiceImg(record,'问题确认表','问题确认表')">上传</span>
          </template>
          <template slot="jielun" slot-scope="text, record">
            <span v-if="record.taskSumInfo" style="color: green;cursor: pointer" @click="onresultModalOpen(record)">查看</span>
            <span v-else style="color:#3498db ;cursor: pointer" @click="onresultModalOpen(record)">输入</span>
          </template>
          <template slot="jieguo" slot-scope="text, record">
              <span v-if="record.taskPass==='待定'" style="color: #3498db;cursor: pointer">待定</span>
              <span v-else-if="record.taskPass==='通过'" style="color: green;cursor: pointer">通过</span>
              <span v-else-if="record.taskPass==='未通过'" style="color: orange;cursor: pointer">未通过</span>
          </template>
          <template slot="caozuo" slot-scope="text, record">
            <a-button v-if="record.taskPass==='待定'&&record.taskStatus==='待执行'" type="link" @click="execRandom(record)">执行检查</a-button>
            <template v-if="record.taskPass==='待定'&&record.taskStatus==='执行中'">
              <a-button type="link" @click="passRandom(record)">通过</a-button>
              <a-divider dashed="true" type="vertical" />
              <a-button type="link" @click="unPassRandom(record)">未通过</a-button>
            </template>
          </template>
        </a-table>
      </a-config-provider>
    </div>
    <input type="file" style="display:none" ref="hiddenFileInput" @change="uploadFileChange" />
    <add-db-random-modal v-if="addDbRandomModalVisable" :visible.sync="addDbRandomModalVisable"
                         :param="addDbRandomModalParam" @addDbRandomClose="onAddDbRandomModalClose"></add-db-random-modal>
    <result-modal  v-if="resultModalVisable" :visible.sync="resultModalVisable"
                   :param="resultModalParam" @dialogBack="onresultModalClose"></result-modal>
  </div>
</template>

<script>
//分页查询接口  ①分页查询SQL
import {getDbRandomPage as getPage} from '../../../api/api'
import {delDbRandomSelected as delPage,addorUpdateDbRandom,upload} from '../../../api/api'
//各个字段  ③查询条件选择组件
import AExtDataPicker from '../../../components/AntDesignExt/All/AExtDataPicker'
import AExtLocalDicSelect from '../../../components/AntDesignExt/All/AExtLocalDicSelect'

import AddDbRandomModal from './AddDbRandomModal'
import ResultModal from './ResultModel'
import _ from 'lodash'
import ExportJsonExcel from "js-export-excel"
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
    //各个字段  ⑤查询条件选择组件
    components: {
        AExtDataPicker, AExtLocalDicSelect, AddDbRandomModal,ResultModal
    },
    data() {
        return {
            locale: zhCN,

            formState: {
                //②查询条件字段名
                name: ''
            },
            params: {},
            // 表头
            columns: [
                {
                    title: "序号",
                    dataIndex: "index",
                    width: "60px",
                },
                {
                    title: "任务编号",
                    dataIndex: "taskCode",
                    width: "150px",
                    ellipsis: true,
                },
                {
                    title: "检查时间",
                    dataIndex: "checkDate",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "任务状态",
                    dataIndex: "taskStatus",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "被检机构名称",
                    dataIndex: "name",
                    width: "150px",
                    ellipsis: true,
                },
                {
                    title: "检查组长",
                    dataIndex: "leaderName",
                    width: "120px",
                    ellipsis: true,
                    // scopedSlots: {customRender: "zhuangtai"},
                },
                {
                    title: "组员及观察员",
                    dataIndex: "zhuanjiaName",
                    width: "210px",
                    ellipsis: true,
                    // scopedSlots: {customRender: "zhuangtai"},
                },
                {
                    title: "现场检查表",
                    dataIndex: "xcjcbName",
                    width: "150px",
                    ellipsis: true,
                    scopedSlots: {customRender: "xianchangjianchabiao"},
                },
                {
                    title: "问题确认表",
                    dataIndex: "wtqrbName",
                    width: "150px",
                    ellipsis: true,
                    scopedSlots: {customRender: "wentiquerenbiao"},
                },
                {
                    title: "检查结论",
                    dataIndex: "taskSumInfo",
                    width: "150px",
                    ellipsis: true,
                    scopedSlots: {customRender: "jielun"},
                },
                {
                    title: "检查结果",
                    dataIndex: "taskPass",
                    width: "150px",
                    ellipsis: true,
                    scopedSlots: {customRender: "jieguo"},
                },
                // {
                //     title: "操作",
                //     dataIndex: "id",
                //     width: "150px",
                //     scopedSlots: {customRender: "caozuo"},
                // },
            ],
            // 表格数据
            dataSource: [],
            // 选中的行
            selectedRowKeys: [],
            selectedRows: [],
            loading: false,
            // 分页器
            pagination: {
                total: 0,
                current: 1,
                pageSize: 5,
                pageSizeOptions: ["5", "15", "35", "45"],
                showSizeChanger: true,
                size: "small",
                showTotal: total => `共${total}条记录 `
            },
            addDbRandomModalVisable: false,
            addDbRandomModalBackChange: null,
            addDbRandomModalParam: null,
            resultModalVisable: false,
            resultModalBackChange: null,
            resultModalParam: null,
            upRecord:null,
            upType:'',
            upSmallType:''
        };
    },
    mounted() {
        this.onSearchPage();
    },
    computed: {
        selectedRowCount() {
            return this.selectedRowKeys.length;
        }
    },
    methods: {
        choiceImg(record,upType,upSmallType) {
            this.upRecord=record;
            this.upType=upType;
            this.upSmallType=upSmallType;
            this.$refs.hiddenFileInput.dispatchEvent(new MouseEvent('click'))
        },
        uploadFileChange(){
            if(this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.pdf')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.jpg')===-1
                &&this.$refs.hiddenFileInput.files[0].name.toLowerCase().indexOf('.png')===-1)
            {
                this.$message.warn('仅允许上传图片或pdf，请将文件先转换为pdf再进行上传!');
                return;
            }
            upload({belongId:this.upRecord.id,belongType:this.upType,belongSmallType:this.upSmallType,file:this.$refs.hiddenFileInput.files[0]}).then(result=>{
                    this.success()
                    this.getData(this.params)
                this.$refs.hiddenFileInput.value = '';
            }).catch(()=>{
                this.$refs.hiddenFileInput.value = '';
            })
        },
        success(updateItem) {
            this.$message.success(
                '操作成功',
                2,
            );
        },
        // 查询
        onSearchPage() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.pagination.current = 1;
            this.params = {
                pageSize: this.pagination.pageSize,
                current: this.pagination.current,
                ...this.formState,
            };
            this.getData(this.params);
        },
        //重置
        onResetSearch() {
            this.$refs.searchForm.resetFields();this.onSearchPage();
        },
        // 翻页
        onPageChange(pagination, filters, sorter) {
            this.pagination = pagination;
            this.params.pageSize = pagination.pageSize;
            this.params.current = pagination.current;
            this.getData(this.params);
        },
        // 请求接口查询数据
        getData(params) {
            this.loading = true;
            getPage(params).then(result => {
                this.pagination.total = result.data.data.total;
                this.pagination.current = result.data.data.current;
                this.pagination.pageSize = result.data.data.size;
                this.dataSource = result.data.data.records.map((item, index) => {
                    item.index = index + 1
                    return item
                });
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        // 复选框变化
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
            let removedItems = [];
            let addItems = [];
            this.selectedRows.forEach(oldSelectedItem => {
                if (!selectedRowKeys.includes(oldSelectedItem.id)) {
                    removedItems.push(oldSelectedItem);
                }
            });
            this.selectedRowKeys.forEach(newKey => {
                let find = false;
                this.selectedRows.forEach(oldSelectedItem => {
                    if (oldSelectedItem.id === newKey) {
                        find = true;
                    }
                });
                if (!find) {
                    this.dataSource.forEach(thisPageItem => {
                        if (thisPageItem.id === newKey) {
                            addItems.push(thisPageItem);
                        }
                    })
                }
            });
            removedItems.forEach(row => {
                this.selectedRows.remove(row)
            });
            this.selectedRows = this.selectedRows.concat(addItems)
        },
        onDelete(record) {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择要删除的数据');
                return
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    delPage(record.id).then(() => {
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        onAddDbRandomModalOpen(record) {
            this.addDbRandomModalParam = {id: record.id};
            this.addDbRandomModalVisable = true;
            //TODO: 无
        },
        onAddDbRandomModalClose() {
            //TODO: 无
            this.getData(this.params)
        },

        onAddDbRandomClick() {
            //TODO:弹出新增面板
        },
        onresultModalOpen(record) {
            this.resultModalParam = {record:record,jielun:record.taskSumInfo};
            this.resultModalVisable = true;
            //TODO: 无
        },
        onresultModalClose(data) {
            data.record.taskSumInfo=data.jieguo;
            addorUpdateDbRandom(data.record).then(() => {
                this.getData(this.params);
            }).catch(err => {
                this.$message.error(err.message);
            });
        },
        // 批量删除
        onBatchDelete() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择要删除的数据');
                return
            }
            let keys = this.selectedRowKeys;
            let funcOK = () => {
                delPage(_.join(keys, ',')).then(() => {
                    this.selectedRowKeys = [];
                    this.selectedRows = [];
                    this.getData(this.params);
                }).catch(err => {
                    this.$message.error(err.message);
                });
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    funcOK();
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        // 导出excel
        onExportExcel() {
            if (this.selectedRowKeys.length == 0) {
                this.$message.error('请选择要导出的数据');
                return
            }
            let sheetColHeader=[];
            let sheetColFilter=[];
            this.columns.forEach(col=>{
                if(col.title !== '操作') {
                    sheetColFilter.push(col.dataIndex)
                    sheetColHeader.push(col.title)
                }
            });
            let exportRows=[];
            let i=0;
            this.selectedRows.forEach(item=>{
                i++;
                let newItem=_.cloneDeep(item);
                newItem.index=i.toString();
                exportRows.push(newItem)
            });
            let option = {};
            option.fileName = "检测机构双随机检查";
            option.datas = [
                {
                    sheetData: exportRows,
                    sheetName: "检测机构双随机检查",
                    sheetFilter: sheetColFilter,
                    sheetHeader: sheetColHeader,
                    columnWidths: [],
                },
            ];

            var toExcel = new ExportJsonExcel(option); //new
            toExcel.saveExcel();
        },
        execRandom(record)
        {

            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    record.taskStatus='执行中';
                    addorUpdateDbRandom(record).then(() => {
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        passRandom(record)
        {

            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    record.taskPass='通过';
                    record.taskStatus='已执行';
                    addorUpdateDbRandom(record).then(() => {
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        unPassRandom(record)
        {

            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    record.taskPass='未通过';
                    record.taskStatus='已执行';
                    addorUpdateDbRandom(record).then(() => {
                        this.getData(this.params);
                    }).catch(err => {
                        this.$message.error(err.message);
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
    },

};
</script>
<style lang="scss" scoped>
  .table {
    .params-form {
      padding-top: 16px;
      padding-left: 20px;
      margin: 16px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      justify-content: space-between;
      border-radius: 8px;
      background-color: rgb(255, 255, 255);
      box-shadow: #1b2f7017 0px 2px 4px 2px;
    }
    .table-content {
      margin: 16px;
      padding: 20px 24px;
      box-shadow: #1b2f7017 0px 2px 4px 2px;
      background-color: rgb(255, 255, 255);
      border-radius: 8px;
      overflow-y: hidden;
      .title {
        padding-left: 12px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: rgba(0, 0, 0, 0.85);
        position: relative;
        margin-bottom: 16px;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
      }
      .title::before {
        content: '';
        position: absolute;
        height: 16px;
        top: calc(50% - 8px);
        left: 0px;
        width: 3px;
        background-color: rgb(36, 113, 210);
      }

      .btn {
        padding-bottom: 15px;
        display: flex;
        justify-content: end;
      }

      /deep/ .ant-table-wrapper {
        .ant-table {
          border-top: 1px solid rgba(15, 41, 61, 0.45);
          border-bottom: 1px solid rgba(15, 41, 61, 0.45);
          border-image: initial;
          border-left: none;
          border-right: none;
        }
        .ant-table-thead {
          background: #fafafa;
        }
        .ant-table-thead > tr > th {
          font-weight: 500;
          line-height: 1;
          color: rgba(21, 40, 77, 0.65);
          background-color: rgb(245, 250, 255);
        }
      }
    }
  }
</style>
